import PricingCard from "./PricingCard";

const PricingGrid = ({ plans, cycle }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mt-10">
    {plans.map(plan => (
      <PricingCard key={plan.id} plan={plan} cycle={cycle} />
    ))}
  </div>
);

export default PricingGrid;
